import { Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import InfoToko from "../../components/InfoToko/InfoToko";
import CardInfoUser from "../../components/InfoAkun/CardInfoUser";
import CardChangePassword from "../../components/InfoAkun/CardChangePassword";
import Spinner from "../../components/Spinner/Spinner";
import FAQ from "../../components/FAQ/FAQ";
import ModalKonfirmasiLogout from "../../components/ModalKonfirmasiLogout/ModalKonfirmasiLogout";
import PengaturanAccountActions from "./components/PengaturanAccountActions";
import PengaturanTabPanel from "./components/PengaturanTabPanel";
import PengaturanTabs from "./components/PengaturanTabs";
import usePengaturanPage from "./hooks/usePengaturanPage";

const Pengaturan = () => {
    const {
        activeTab,
        closeLogoutModal,
        handleTabChange,
        isLogoutModalOpen,
        openLogoutModal,
        showJuraganButton,
        showUkmAttention,
        showUkmTab,
        userStatus,
    } = usePengaturanPage();

    if (userStatus === "loading") {
        return (
            <Stack
                display="grid"
                gridTemplateColumns="1fr"
                alignItems="center"
                height="100vh"
                position="relative"
            >
                <Spinner />
            </Stack>
        );
    }

    return (
        <React.Fragment>
            <Typography fontWeight="bold" variant="h5" sx={{ marginY: 2 }}>
                Pengaturan
            </Typography>
            <Box>
                <Box>
                    <PengaturanTabs
                        showUkmAttention={showUkmAttention}
                        showUkmTab={showUkmTab}
                        value={activeTab}
                        onChange={handleTabChange}
                    />
                </Box>
                <PengaturanTabPanel value={activeTab} index={0}>
                    <Grid container spacing={3}>
                        <CardInfoUser />
                        <CardChangePassword />
                        <PengaturanAccountActions
                            showJuraganButton={showJuraganButton}
                            onLogout={openLogoutModal}
                        />
                    </Grid>
                </PengaturanTabPanel>
                <PengaturanTabPanel value={activeTab} index={1}>
                    <InfoToko />
                </PengaturanTabPanel>
                <PengaturanTabPanel value={activeTab} index={2}>
                    <FAQ />
                </PengaturanTabPanel>
            </Box>
            <ModalKonfirmasiLogout
                open={isLogoutModalOpen}
                onClose={closeLogoutModal}
            />
        </React.Fragment>
    );
};

export default Pengaturan;
